import { DateTime } from 'luxon';

const autobirds = [
  'AMOY', //brdl 1
  'COLO',
  'DOWO',
  'MERL',
  'AMGO',
  'STJA',
  'HOME',
  'TUVU',
  'SNOW',
  'AMDI',
  'ANHU',
  'NOCA',
  'PABU',
  'PUMA',
  'LAAL',
  'MALL',
  'SNKI',
  'ANHI',
  'GRCA',
  'SAGU',
  'OSPR',
  'AMCR',
  'PUFI',
  'CAWA',
  'WEGR',
  'CITE',
  'KIEI',
  'COPO',
  'WESO',
  'KILL',
  'WHIB',
  'COTE', //
  'BLJA',
  'PIPL',
  'GOEA',
  'CLRA',
  'BAOR',
  'RUBL',
  'EATO',
  'WFIB',
  'MADU',
  'BARS',
  'FOSP',
  'AMAV',
  'BCCH',
  'REKN',
  'SEOW',
  'COHA',
  'WILL',
  'SORA',
  'BUFF',
  'WODU',
  'WAVA',
  'LETE',
  'RAZO',
  'HOPU',
  'COGO', //After this, its ABA only!
  'YERA',
  'BEKI',
  'CONI',
  'BTGR',
  'LARB',
  'CMWA',
  'PHVI',
  'SOSA',
  'COGA', //
  'BUOW',
  'CRTE',
  'JAWE',
  'PTSN',
  'ROHA',
  'SWSN',
  'LOSH',
  'WCGR',
  'RUTU',
  'EWCS',
  'ACGO',
  'CORA',
  'CHSP',
  'WHTE',
  'FATE',
  'HEEG',
  'ZEND',
  'BNST',
  'BRSH',
  'PAAU',
  'GRYE',
  'AMRO',
  'BRPE',
  'ATSP',
  'CANT',
  'PHPE',
  'MSCR',
  'ANEU',
  'COLO',
  'YEJU',
  'SOSH',
  'PALO',
  'CAEG',
  'RHAU',
  'WHAU',
  'BCNH',
  'LSGO',
  'WAVI',
  'STRS',
  'BRNO',
  'TUDU',
  'BCPE',
  'EGWT',
  'ILTE',
  'ZEBD',
  'MAFD',
  'COGD',
  'GHJU',
  'BLVU',
  'VGSW',
  'CALC',
  'GARG',
  'NOHA',
  'BLBU',
  'BHGU',
  'WTTR',
  'MAFR',
  'BIOO',
  'CAMA',
  'PSWS',
  'ARTE',
  'PAGP',
  'OLSP',
  'PUGA',
  'BWVI',
  'STEI',
  'LBBG',
  'HETA',
  'RNDU',
  'GYRF',
  'KIEI',
  'CRAU',
  'RUGD',
  'BARG',
  'YNAL',
  'LEGR',
  'LEFR',
  'LEAU',
  'CLGR',
  'CARC',
  'WATA',
  'RCCA',
  'SUSC',
  'NSHO',
  'BRQD',
  'GBTE',
  'WSPL',
  'MCMO',
  'SCTA',
  'GRFR',
  'MODO',
  'HOLA',
  'WOST',
  'SAFI',
  'WWTE',
  'EAGR',
  'KWQD',
  'LBMU',
  'PRSP',
  'MOPE',
  'JAMS',
  'ICTO',
  'YGVI',
  'CACG',
  'BRNG',
  'SHAL',
  'WHSW',
  'WISN',
  'CLSW',
  'LTDU',
  'BLAG',
  'SPDO',
  'LAAL',
  'SPOS',
  'WHOS',
  'WFSP',
  'PHAI',
  'HBKI',
  'CATE',
  'WESP',
  'LBHE',
  'BGNO',
  'BOPE',
  'CAPE',
  'PRPP',
  'LAZB',
  'ELTE',
  'EMGO',
  'PBWH',
  'AWPE',
  'BFAL',
  'BFGR',
  'CHSH',
  'BVSH',
  'AMGP',
  'PUEB',
  'LEBI',
  'YEBI',
  'INBU',
  'SEPL',
  'GREG',
  'COSN',
  'FTSP',
  'CAGO',
  'WIPH',
  'WTKI',
  'BHVI',
  'HERG',
  'RBGU',
  'NRWS',
  'TUPU',
  'BULS',
  'SNPE',
  'LBDO',
  'EUWI',
  'EUGP',
  'WTGD',
  'RSHA',
  'BBWD',
  'TRSH',
  'SWSP',
  'XAMU',
  'CALT',
  'WTHA',
  'PFSH',
  'NOJA',
  'WCSP',
  'GTTO',
  'BLSP',
  'GBBG',
  'DOVE',
  'GRHA',
  'SCIB',
  'POJA',
  'GREJ',
  'GLGU',
  'LESA',
  'BAHS',
  'STHA',
  'PLVI',
  'DICK',
  'HAWD',
  'CANV',
  'BBPL',
  'BLTE',
  'GADW',
  'WEBL',
  'RUQD',
  'HAGO',
  'BUPE',
  'MAGO',
  'WHIT',
  'PIGU',
  'GUMU',
  'EADO',
  'RFCO',
  'HAST',
  'SURF',
  'REDH',
  'NSHR',
  'WHIM',
  'TBMU',
  'RUFF',
  'SCBS',
  'HISP',
  'BLKI',
  'TRHE',
  'RTTR',
  'STKI',
  'KAOO',
  'LBCU',
  'WCSE',
  'BWST',
  'SACR',
  'GRCO',
  'ICGU',
  'TWFG',
  'PRFA',
  'WIPL',
  'EUDO',
  'BLOY',
  'GBMA',
  'SPSK',
  'YCNH',
  'BWTE',
  'SWHA',
  'HOGR',
  'BLNO',
  'YBCR',
  'RUFS',
  'RFBO',
  'UPSA',
  'FFSH',
  'BLGR',
  'MAMU',
  'RLHA',
  'RTHA',
  'FSSP',
  'ATPU',
  'HAPE',
  'GURA',
  'LIST',
  'SBSP',
  'DUNL',
  'HRLH',
  'SPSA',
  'VABU',
  'FGSP',
  'YFGU',
  'MOBL',
  'ATBR',
  'BCSP',
  'HACO',
  'GTTA',
  'CBHA',
  'CSSS',
  'BLGU',
  'LISH',
  'LTJA',
  'BANP',
  'WCPI',
  'ROYT',
  'AMWO',
  'STAL',
  'BAEA',
  'WWDO',
  'BASA',
  'FISP',
  'BATE',
  'PUSW',
  'WOSA',
  'SBDO',
  'PESA',
  'GSGO',
  'GWGU',
  'HCRE',
  'BLRA',
  'PBGR',
  'EBRA',
  'BLSK',
  'SNEG',
  'CUSA',
  'ASSP',
  'LEYE',
  'BOWA',
  'ROSP',
  'ROGO',
  'HUGO',
  'ARLO',
  'FUWD',
  'ORJU',
  'DCCO',
  'GBHE',
  'GRSH',
  'PUSA',
  'LASP',
  'SLSH',
  'CUGR',
  'MODU',
  'CRPL',
  'INDO',
  'EUWO',
  'GRAT',
  'SCMU',
  'BTSP',
  'WESA',
  'FRGU',
  'COTE',
  'HOME',
  'COEI',
  'ALTE',
  'BBRA',
  'COSA',
  'RNPH',
  'PRTA',
  'MIKI',
  'SCJU',
  'ROGU',
  'MUDU',
  'BRJA',
  'NOPI',
  'ANMU',
  'WRSA',
  'BBSA',
  'COPE',
  'WEGU',
  'AFCD',
  'HYAL',
  'GRHE',
  'LTST',
  'EABL',
  'CCSP',
  'MOPL',
  'PHTD',
  'WRSP',
  'ROSA',
  'WETA',
  'WHCR',
  'CRMU',
  'PABU',
  'PECO',
  'LHSP',
  'COMU',
  'SAGU',
  'TRUS',
  'PBDU',
  'GWFG',
  'COME',
  'REVI',
  'BLSC',
  'WWJU',
  'WIWD',
  'LESC',
  'HAGA',
  'RNST',
  'SOSP',
  'BRBO',
  'BTCU',
  'SATE',
  'YBLO',
  'LESB',
  'DSSP',
  'MEGU',
  'REEG',
  'SPTO',
  'GLIB',
  'WHSP',
  'PYRR',
  'LTSP',
  'SCGO',
  'SBGU',
  'CAYT',
  'RLKI',
  'BRAC',
  'BLGO',
  'ANHI',
  'MAGU',
  'MABO',
  'CPOC',
  'AMMU',
  'HARD',
  'RBTR',
  'HOWR',
  'GRSK',
  'AMFL',
  'RNGR',
  'HRSH',
  'BLBR',
  'LADU',
  'IVGU',
  'STSA',
  'LIMP',
  'NOMO',
  'SESA',
  'BGSG',
  'RUDU',
  'CASW',
  'TRPE',
  'CADO',
  'MASH',
  'VIRA',
  'ECDO',
  'BFBO',
  'SPEI',
  'NOLA',
  'TRSP',
  'WTSH',
  'RBGR',
  'SHAS',
  'WEGR',
  'BNTE',
  'MWCS',
  'PEFA',
  'MUSW',
  'KIRA',
  'NOFU',
  'BBAL',
  'VEER',
  'FEHA',
  'GRSC',
  'THGU',
  'LRSP',
  'BAGO',
  'RWSP',
  'AMWI',
  'GCSP',
  'TAPE',
  'WISP',
  'TABG',
  'CBRA',
  'CITE',
  'PRHE',
  'LIGU',
  'CAGU',
  'SNPL',
  'LITE',
  'LEGP',
  'YBCA',
  'TRES',
  'SHOS',
  'FOTE',
  'RTLO',
  'BTPI',
  'PFGO',
  'BANS',
  'BLTU',
  'BRTE',
  'GWHE',
  'BWPE',
  'LWFG',
  'ABDU',
  'BTGU',
  'RBPI',
  'SSHA',
  'CGRE',
  'NECO',
  'YTVI',
  'WTDO',
  'SUTA',
  'MASA',
  'BHGR',
  'YFGR',
  'PAJA',
  'CAJA',
  'RBME',
  'BOGU',
  'CLTE',
  'LCGO',
  'AMCO',
  'ZTHA',
  'BWHA',
  'RCSP',
  'SAND',
  'NOGO',
  'SOTE',
  'WWSC',
  'ROST',
  'REPH',
  'CRRA',
  'AMBI',
  'NOGA',
  'WTSP',
  'PSSH',
  'NABO',
  'AGWT',
  'HWHA',
  'MEDU',
  'LAGU',
  'RRKN',
  'SOAL',
];

let today = new Date();
let dd = String(today.getDate()).padStart(2, '0');
let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
let yyyy = today.getFullYear();

const UTCToday = mm + '/' + dd + '/' + yyyy;

function treatAsUTC(date: string | Date) {
  let result = new Date(date);
  return result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
}

function daysBetween(startDate: string, endDate: string) {
  let millisecondsPerDay = 24 * 60 * 60 * 1000;
  return (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay;
}

let autobrdlcount = daysBetween('1/23/2022', UTCToday);

let autobird = autobirds[autobrdlcount - 1];

const brdlcount = 'BRDL ' + autobrdlcount;
const brdl = autobird;

export function getBrdl(date: Date) {
  return autobirds[
    daysBetween('1/23/2022', DateTime.fromJSDate(date).toFormat('M/dd/yyyy'))
  ];
}
